import { Button } from "@mantine/core";
import { net } from "utils/net";

import { usePickupRequest } from "hooks";
import { useAuth } from "providers/auth";
import { useState } from "react";
import { useParams } from "react-router";

export function OrderCreatedButtonComponent() {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { id } = useParams();
  const { pickupRequest, mutate } = usePickupRequest({ id });
  const { accessToken } = useAuth();

  async function handleClick() {
    try {
      setIsLoading(true);
      if (!accessToken) throw new Error("No access token");
      if (!pickupRequest) throw new Error("No pickup request");

      const url = `/pickup-requests/${id}/status`;
      const netInstance = net(accessToken);
      await netInstance.patch(url, { status: "created" });

      await mutate();
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  if (!pickupRequest) return <></>;
  if (pickupRequest.status !== "pending") return <></>;
  return (
    <Button onClick={handleClick} loading={isLoading}>
      Mark as Order Created
    </Button>
  );
}
